import React from 'react';
import { cn } from '../lib/utils';

export interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Only prose has a reading cap. Work screens always fill the available canvas. */
  prose?: boolean;
}

export function PageContainer({ prose = false, className, ...props }: PageContainerProps) {
  return (
    <div
      {...props}
      data-page-container
      className={cn(
        'w-full min-w-0 px-gutter py-4 sm:px-gutter-wide',
        prose && 'max-w-prose',
        className,
      )}
    />
  );
}
